import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import TippyTooltipWrapper from "../../../../charts/Tooltip/TippyTooltipWrapper";
import {
  initDashBoardLoader,
  updateSiteConfiguration,
} from "../../../../store/actions";
import { updateFiltersPageVisibility } from "./helper";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";
import Flex from "../../../../UI/Flex/Flex";

const ControlsMenu = styled.div`
  width: 220px;
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-left: 5px;
`;

const LinkStyled = styled(Link)`
  &:hover {
    text-decoration: underline;
  }
`;

export default function FilterControls({ filter }) {
  const siteConfig = useSelector((state) => state.siteConfiguration);
  const { activeTab } = useSelector((state) => state.layout);

  const dispatch = useDispatch();
  const theme = useTheme();

  async function removeFilterFromPage(e) {
    e.stopPropagation();

    const res = {
      ...siteConfig,
      menuFilters: {
        ...siteConfig.menuFilters,
        list: updateFiltersPageVisibility(
          filter.uuid,
          siteConfig.menuFilters.list,
          activeTab?.uuid
        ),
      },
    };

    // do not remove this await
    // 'await' has no effect on the type of this expression. message is not true
    await dispatch(updateSiteConfiguration(res));
    dispatch(initDashBoardLoader(activeTab?.slug));
  }

  const { label } =
    siteConfig.menuFilters?.dataSources?.find(
      (ds) => ds.value === filter.dataSourceUuid
    ) ?? {};

  return (
    <div style={{ position: "relative" }}>
      <TippyTooltipWrapper
        content={
          <ControlsMenu>
            <Flex direction="column" gap="0.5rem" style={{ width: "100%" }}>
              <LinkStyled
                to={`/admin/data-settings/mapping/data-sources/${filter.dataSourceUuid}`}
                target="_blank"
                title="Open Data Source In New Page"
                onClick={(e) => e.stopPropagation()}
              >
                {label}
              </LinkStyled>

              <LinkStyled
                to={`/admin/site-configuration?tab=Filters&search=${filter.uuid}`}
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                View in Site Configuration
              </LinkStyled>
            </Flex>

            {siteConfig.processing ? (
              <FontAwesomeIcon
                icon={["fas", "spinner"]}
                pulse
                style={{ marginLeft: 5 }}
              />
            ) : (
              <FontAwesomeIcon
                icon={["fas", "trash"]}
                title="Remove menu filter from page"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                  color: theme.notification.errorMain,
                }}
                onClick={removeFilterFromPage}
              />
            )}
          </ControlsMenu>
        }
        placement="right"
        trigger="click"
        interactive={true}
      >
        <FontAwesomeIcon
          icon={["fal", "cog"]}
          onClick={(e) => e.stopPropagation()}
        />
      </TippyTooltipWrapper>
    </div>
  );
}
